const classes = {
  nonClickableContainer: {
    cursor: 'auto',
    marginLeft: '10px',
    padding: '8px',
  },
};

export default classes;
